import { PermissionsContext } from 'contexts/PermissionsContext';
import React from 'react';
import { WorkingCapitalFiltersProvider } from '../Contexts/WorkingCapitalFiltersProvider';
import { SavingCalculationProvider } from '../Contexts/SavingCalculationProvider';
import { BenchmarkProvider } from '../Contexts/BenchmarkProvider';
/**
 * withCategoryManagementProviders HOC Component
 * @param {JSX} WrappedComponent - Accepts a component and gives a Wrapped componets with Context Providers
 */

// Higher Order Component (HOC) that wraps a component with multiple providers
const withCapitalMarketProviders = WrappedComponent => {
	// Return a new component with added context providers
	return function SpendControllerWrapper(props) {
		return (
			<>
				<WorkingCapitalFiltersProvider>
					<SavingCalculationProvider>
						<BenchmarkProvider>
							<PermissionsContext.Consumer>
								{({ permissions }) => (
									<WrappedComponent {...props} permissions={permissions} />
								)}
							</PermissionsContext.Consumer>
						</BenchmarkProvider>
					</SavingCalculationProvider>
				</WorkingCapitalFiltersProvider>
			</>
		);
	};
};

export default withCapitalMarketProviders;
